export const GET_USERS_ACTIONS = "GET_USERS_ACTIONS";
export const SET_USERS_ACTIONS = "SET_USERS_ACTIONS";

export const GET_USERS_ACTIONS_FILTERS = "GET_USERS_ACTIONS_FILTERS";
export const SET_USERS_ACTIONS_FILTERS = "SET_USERS_ACTIONS_FILTERS";
export const USERS_ACTIONS_LOADER_FILTER = "USERS_ACTIONS_LOADER_FILTER";

export const USERS_ACTIONS_LOADER = "SET_USERS_ACTIONS_LOADER";